import { searchTagsApiDetails } from '../../constants/server.constants';
import gateway from '../../middlewares/axios/gateway';

const searchTagsService = async (query) => {
  const response = await gateway.post(searchTagsApiDetails.path, {
    query,
  });

  const { data, error } = response.data;

  return { data, error };
};

export default searchTagsService;
